import React from "react"
import { Outlet, useNavigate } from 'react-router-dom'

import Footer from "../../components/Footer"
import RicoLogo from "../../assets/images/rico_logo.jpeg"

function MainLayout({ children }) {
    const navigate = useNavigate();

    return <div className="container min-vh-100 d-flex flex-column">
        <header className="py-3">
            <div className="container d-flex align-items-center" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                <div>
                    <img src={RicoLogo} alt="Logo" width="100" height="auto" />
                </div>
                <div>
                    <h1 className="m-0">Direct2Israel</h1>
                </div>
            </div>
        </header>
        <div className="row flex-grow-1 d-flex justify-content-center align-items-center">
            <div className="col">
                <Outlet />
            </div>
        </div>
        <Footer />
    </div>
}

export default MainLayout
